let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6Rcy9")).then(() => parcelRequire('bn69C'));